import request from '@/utils/request';

//获取二维码buffer
export function getQrCodeBuffer(values) {
  return request('/wechat/qrcode/queryPic', {
    method: 'POST',
    data: values,
  });
}

// 分页查询 二维码管理-列表
export function qrcodePage(values) {
  return request('/wechat/mp/qrcodePage', {
    method: 'POST',
    data: values,
  });
}

// 删除二维码
export function deleteQrCode(values) {
  return request('/wechat/mp/deleteQrcode', {
    method: 'POST',
    data: values,
  });
}
